import { List } from "immutable"
import * as React from "react"
import { ApiResult } from "../../../Shared/api/apiTypes"
import { getDrupalVacancies } from "../../custom_api/api"
import { library } from "../../libraries"
import { Teaser } from "./teaser"

export interface VacancyOverviewBlockProps {
  readonly title?: string
  readonly html: string
  readonly category_id: number
}

export interface OverviewVacancy {
  title: string
  subtitle: string
  url: string
  locations: string
}

interface VacancyOverviewBlockState {
  vacancies: ApiResult<List<OverviewVacancy>>
}

export class VacancyOverviewBlock extends React.Component<VacancyOverviewBlockProps, VacancyOverviewBlockState> {
  constructor(props: VacancyOverviewBlockProps) {
    super(props)
    this.state = { vacancies: "loading" }
  }

  async componentDidMount() {
    let vacanciesData = await getDrupalVacancies(List([this.props.category_id]))

    if (vacanciesData !== "error") {
      this.setState(s => ({ ...s, vacancies: List<OverviewVacancy>(vacanciesData) }))
    }
  }

  render() {
    const copy = library().copy.vacancies
    let p = this.props
    let s = this.state

    return (
      <section className="block block--content-grid block--vacancies container--lg align--center">
        {(p.title || p.html) && (
          <header className="block__header container--m align--center">
            <h2 className="block__title title--l container--xs">{p.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: p.html }} className="block__intro container--s text--styled" />
          </header>
        )}

        {s.vacancies !== 'error' && s.vacancies !== 'loading' && (
          !s.vacancies.isEmpty()
            ? <>
              <ul className="teasers row">
                {s.vacancies.map((v, i) => (
                  <Teaser
                    key={`vacancy_overview_${i}`}
                    extraClasses="vacancy col-xs-12 col-sm-6"
                    linkUrl={v.url}
                    headingLevel="h3"
                    title={v.title}
                    intro={v.subtitle}
                    locationFooter={v.locations.split(',').length == 1 ? v.locations : "Meerdere locaties"}
                  />
                ))}
              </ul>
            </>
            : <div className="text--styled">
              <p className="weight--bold container--s">{copy.noVacanciesFound}</p>
            </div>
        )}
      </section>
    )
  }
}

{/* TH: Added to styleguide! */}
